import { NavLink, Outlet } from "react-router-dom";
import { Workflow, LayoutDashboard, Lightbulb, BookOpen, Sparkles, Map } from "lucide-react";
import { cn } from "@/lib/utils";

const NAV_ITEMS = [
  { to: "/studio", icon: LayoutDashboard, label: "Start Here", end: true },
  { to: "/studio/techniques", icon: Lightbulb, label: "Techniques" },
  { to: "/studio/sdlc", icon: BookOpen, label: "SDLC Reference" },
  { to: "/studio/genius-labs", icon: Sparkles, label: "Genius Labs" },
  { to: "/studio/guide", icon: Map, label: "Guide" },
];

export default function StudioLayout() {
  return (
    <div className="min-h-screen flex bg-background">
      {/* Sidebar */}
      <aside className="hidden md:flex w-56 border-r border-border bg-sidebar shrink-0 flex-col">
        <div className="px-5 py-5 border-b border-sidebar-border">
          <div className="flex items-center gap-2.5">
            <Workflow className="h-5 w-5 text-accent" />
            <div>
              <h1 className="text-sm font-display font-bold tracking-tight text-sidebar-foreground">
                BA Workbench
              </h1>
              <p className="text-[10px] text-muted-foreground font-body">
                Analysis · Diagrams · Docs
              </p>
            </div>
          </div>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/studio"}
              className={({ isActive }) =>
                cn(
                  "flex items-center gap-2.5 px-3 py-2 rounded-md text-sm font-body transition-colors",
                  isActive
                    ? "bg-sidebar-accent text-sidebar-accent-foreground font-semibold"
                    : "text-sidebar-foreground hover:bg-sidebar-accent/50"
                )
              }
            >
              <item.icon className="h-4 w-4" />
              {item.label}
            </NavLink>
          ))}
        </nav>
      </aside>

      {/* Mobile header */}
      <div className="flex-1 flex flex-col min-w-0">
        <header className="md:hidden border-b border-border px-4 py-3 flex items-center justify-between bg-sidebar">
          <div className="flex items-center gap-2">
            <Workflow className="h-5 w-5 text-accent" />
            <span className="text-sm font-display font-bold">BA Workbench</span>
          </div>
          <nav className="flex gap-1">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/studio"}
                className={({ isActive }) =>
                  cn(
                    "p-2 rounded-md transition-colors",
                    isActive
                      ? "bg-sidebar-accent text-accent"
                      : "text-muted-foreground"
                  )
                }
              >
                <item.icon className="h-4 w-4" />
              </NavLink>
            ))}
          </nav>
        </header>
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
